import { Form } from '@unform/web';
import React, { useEffect, useState } from 'react';
import { FaBell, FaCertificate, FaCheckCircle, FaChevronRight, FaExclamationCircle, FaFile, FaIdBadge, FaImages, FaQuestionCircle, FaReceipt, FaRegIdBadge, FaSubscript, FaTicketAlt, FaTrophy, FaUser } from 'react-icons/fa';
import { FiMessageCircle } from 'react-icons/fi';

import { IconType } from 'react-icons/lib';
import { useAuth } from '../../../../hooks/Auth';
import { useConfiguration } from '../../../../hooks/Configuration';
import api from '../../../../services/api';



import { Container, ContainerWhite } from './styles';
import { useParams } from 'react-router-dom';
import { useModal } from '../../../../hooks/Modal';

import { useLoading } from '../../../../hooks/LoadingHook';
 
import TicketList from '../TicketList';
import SaleList from '../SaleList';
import SubscriptionProfile from '../SubscriptionProfile';
import TicketListProfile from '../TicketListProfile';
import SaleListProduct from '../SaleListProduct';
import SelectSimple from 'src/components/Forms/SelectSimple';





const SaleReportCoordenador: React.FC<Record<string, any>> = ({ project, currentValue, changeProject, projectOptions }) => {

  const { user } = useAuth();
  const { addLoading, removeLoading } = useLoading();
  const { addModal, removeModal } = useModal();
  const [products, setProducts] = useState<Record<string, any>[]>([]);
  const [sales, setSales] = useState<Record<string, any>[]>([]);
  const [contador, setContador] = useState(5)
  const [coupons, setCoupons] = useState<Record<string, any>[]>([]);
  const [courtesies, setCourtesies] = useState<Record<string, any>[]>([]);
  const [accessType, setAccessType] = useState('Simplificado')
  const [page, setPage] = useState('ticket');


  const load = async () => {
    addLoading({ title: 'Carregando', key: 'loading' });

    const profile = await api.get('get-my-profile');

    const couponsAndCourtesies = await api.get(`/list-coupons-and-courtesies-by-project/${project?.url}`, {
      params: {
        limitItems: 10000,
        where: { project_id: project?.url },
        export_data: {
          _id: { ref: '_id', label: 'ID', search: true },
          title: { ref: 'title', label: 'Título', search: true },
          is_subscription: { ref: 'is_subscription', label: 'É Inscrição', search: true },
        }

      }
    });

    const productsList = await api.get('/list-products-by-project', {
      params: {
        limitItems: 10000,
        where: { project_id: project?.url },
        export_data: {
          _id: { ref: '_id', label: 'ID', search: true },
          title: { ref: 'title', label: 'Título', search: true },
          is_subscription: { ref: 'is_subscription', label: 'É Inscrição', search: true },
        }

      }
    });

    const salesList = await api.get('/list-sale-products-by-project', {
      params: {
        limitItems: 10000,
        where: { project_id: project?.url, payment_status_id: { "$ne": "cancelled" } },
        export_data: {
          _id: { ref: '_id', label: 'ID', search: true },
          client_id: { ref: 'client_id', label: 'Titular', search: true },
          payer_id: { ref: 'payer_id', label: 'Comprador', search: true },
          product_id: { ref: 'product_id', label: 'producte', search: true },
          total: { ref: 'total', label: 'Total', search: true },
          payment_status_id: { ref: 'payment_status_id', label: 'Status de pagamento', search: true },
        }

      }
    });

    const getPaymentStatus = {
      waiting: 'Aguardando pagamento',
      paid: 'Pago',
      cancelled: 'Cancelado',
      expired: 'Expirado',
    };

    const getPaymentMethod = {
      boleto: 'Boleto',
      cortesy: 'Cortesia',
      courtesy: 'Cortesia',
      credit_card: 'Cartão de crédito',
      pix: 'PIX'
    }

    const saleContent: Array<Record<string, any>> = [];
    salesList.data.rows.map(item => {
      const product = productsList?.data?.rows.find(i => i?._id?.toString() === item?.product_id)
      const courtesy = item?.cortesy_hash_id ? couponsAndCourtesies?.data?.courtesies?.find(i => i?.hash === item?.cortesy_hash_id)?.title || item?.courtesy_hash : '';

      item.payment_method_id_title = getPaymentMethod?.[item?.payment_method_id];
      item.payment_status_id_title = getPaymentStatus?.[item?.payment_status_id];
      item.product_title = item?.product_id_response?.title;
      item.product_id_response = product;
      item.courtesy = courtesy;
      saleContent.push(item);

    })
    setAccessType(profile?.data?.coordinator_access)
    setCourtesies(couponsAndCourtesies?.data?.courtesies)
    setCoupons(couponsAndCourtesies?.data?.coupons)
    setSales(saleContent)
    setProducts(productsList?.data?.rows)
    removeLoading('loading')
  }

  useEffect(() => {
    if (project?.url) {
      load();
    }

  }, [project])

  const changeProjectModal = () => {
    

    addModal({
      key: 'modal',
      theme: 'whiteModalMedium',
      title: '', content: <>


        <div className='column pad'>

          <p style={{ color: '#333', fontWeight: 'bold' }}>{project?.title}</p>
          <br />
          <p style={{ color: '#333', padding: '10px' }}>ALTERAR PROJETO:</p>
          <div className='column-start gap-xs'>
            {projectOptions?.map(item => {
              if (item?.url === project?.url) {
                return <></>
              }
              return <nav className="scaleOnHover selectCard" onClick={() => { changeProject(item?.value); removeModal('modal') }} ><FaChevronRight /> {item?.label}</nav>

            })}
          </div>
        </div>

      </>,
    })

  }



  return <Container>
    <div className='row-to-column' style={{ width: '100%', justifyContent: 'center', borderBottom: '2px solid #ddd', maxWidth: '100%' }}>
      <div className='full-width row-to-column' style={{ maxWidth: '1500px', justifyContent: 'space-between', }}>
        <div className='row-to-column-start' style={{ width: 'auto' }} >
          <button className='greenButton2' onClick={() => changeProjectModal()}>Alterar projeto</button>

          <h2 style={{ padding: '10px' }}>{project?.title}</h2>

        </div>
        <div className='selectorDiv' style={{ width: '100%', maxWidth: '300px', justifyContent: 'flex-end' }}>

          <button className={page === 'ticket' ? 'button buttonColored' : 'button'} onClick={() => setPage('ticket')}>Inscrições</button>
          <button className={page === 'sale-product-data' ? 'button buttonColored' : 'button'} onClick={() => setPage('sale-product-data')}>Dados dos inscritos</button>
          { /* 
        <button className={page === 'ticket-profile' ? 'button buttonColored' : 'button'} onClick={() => setPage('ticket-profile')}>Perfil das Inscrições</button>

        <button className={page === 'sale' ? 'button buttonColored' : 'button'} onClick={() => setPage('sale')}>Pagamentos</button>
        <button className={page === 'profile' ? 'button buttonColored' : 'button'} onClick={() => setPage('profile')}>Perfil do inscrito</button>
*/}
        </div>
      </div>
    </div>
    {page === 'ticket' ? <TicketList accessType={accessType} sales={sales} products={products} project={project} /> : <></>}
    {page === 'sale-product-data' ? <SaleListProduct accessType={accessType} coupons={coupons} courtesies={courtesies} sales={sales} products={products} project={project} /> : <></>}
    {page === 'ticket-profile' ? <TicketListProfile project={project} /> : <></>}
    {page === 'sale' ? <SaleList project={project} /> : <></>}
    {page === 'profile' ? <SubscriptionProfile project={project} /> : <></>}
  </Container>






}
export default SaleReportCoordenador;
